import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const DETECTION_OPTIONS = {
  order: ['navigator'],
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    /* lng: 'en', */
    load: 'unspecific',
    backend: {
      // Translation file path
      loadPath: '/i18n/{{ns}}/{{lng}}.json',
    },
    // Array of allowed languages
    supportedLngs: ['en', 'sv', 'es', 'pt', 'fi', 'et'],
    /* Will consider variants as supported when the main language
    is. E.g. en-US will be valid if en is in supportedLngs */
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    debug: false,
    /* Can have multiple namespace, in case you want to divide a huge 
    translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    detection: DETECTION_OPTIONS,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
  });

export default i18n;
